import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-check-circleless-white",
  "use": "icon-check-circleless-white-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#ffffff\" id=\"icon-check-circleless-white\">\n\r<g id=\"icon-check-circleless-white_SVGRepo_bgCarrier\" stroke-width=\"0\"></g>\n\r<g id=\"icon-check-circleless-white_SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></g>\n\r<g id=\"icon-check-circleless-white_SVGRepo_iconCarrier\"> <path d=\"M4 12.6111L8.92308 17.5L20 6.5\" stroke=\"#ffffff\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /> </g>\n\r</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/check-circleless-white.svg
// module id = R7sp
// module chunks = 175